<script lang="ts">
  import { cn } from '$lib/utils';
  import { cva } from 'class-variance-authority';

  export let element: undefined | HTMLInputElement = undefined;

  let className: undefined | string = undefined;
  export { className as class };

  export let checked: boolean | undefined = undefined;
  export let disabled: boolean | undefined = undefined;
  export let label: string | undefined = undefined;

  const base = cva(
    `
  relative 
  w-8 
  h-4.5 
  bg-primary/8 
  hover:bg-primary/14 
  rounded-full 
  
  after:absolute 
  after:top-0.5 
  after:start-0.5 
  after:bg-highlight 
  after:rounded-full 
  after:h-3.5 
  after:w-3.5 
  after:transition-all 

  peer 
  peer-checked:after:translate-x-full 
  rtl:peer-checked:after:-translate-x-full 
  peer-checked:bg-accent 
  peer-checked:hover:bg-accent-contrast 
  peer-disabled:bg-primary/4 
  peer-disabled:opacity-40 
  peer-checked:peer-disabled:bg-accent
  `
  );
</script>

<label for={element?.id} class={cn('inline-flex items-center cursor-pointer', className)}>
  <input
    bind:this={element}
    bind:checked
    {disabled}
    type="checkbox"
    class="peer sr-only"
    on:change
    on:mouseenter
    on:mouseleave
    on:click
    on:focus
    on:blur
    {...$$restProps}
  />
  <div class={cn(base())}></div>
  {#if label}
    <span class="ms-2 cursor-pointer font-semibold">{label}</span>
  {/if}
</label>
